(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('medication', {
            parent: 'entity',
            url: '/medication',
            data: {
                authorities: [],
                pageTitle: 'Medications'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medication/list/medication.html',
                    controller: 'MedicationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATIONS];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATIONS, access);
            }]
        });
    }
})();
